
import React, { useContext } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'

import PromoProcess from './PromoProcess'

import NotFound from './NotFound'
import ServerError from './ServerError'
import Unauthorized from './Unauthorized'

import AccountHome from './account/Home'
import AccountChangePassword from './account/ChangePassword'
import AccountSettings from './account/Settings'
import AccountPosts from './account/Posts'
import AccountAffiliate from './account/Affiliate'
import SavedSearches from './account/SavedSearches'
import CreditsAndPoints from './account/CreditsAndPoints'
import AddFunds from './account/AddFunds'
import AccountCommunicate from './account/Communicate'
import Threads from './account/messages/Threads'
import Thread from './account/messages/Thread'
import BusinessProfile from './account/BusinessProfile'
import BusinessLogo from './account/BusinessLogo'

import Leads from './account/leads/Index'
import LeadCreate from './account/leads/Create'
import LeadView from './account/leads/View'
import LeadEdit from './account/leads/Edit'

import BannerList from './account/banner/List'
import BannerCreate from './account/banner/Create'
import BannerEdit from './account/banner/Edit'
import BannerPay from './account/banner/Pay'
import BannerView from './account/banner/View'
import BannerPreview from './account/banner/Preview'

import AppContext from '../contexts/AppContext'

const PrivateRoute = ({component: Component, ...rest}) => {
	const { authServices, data } = useContext(AppContext)
	const { isReady } = data
	if(authServices.isLoggedIn() && isReady){
	    return <Route {...rest} render={props => (<Component {...props} />)} />
	}else{
		if(isReady){
			const url = '/login' + (document.location?.pathname ? ('#' + document.location.pathname + (document.location.hash ? document.location.hash : '')) : '')
			document.location.href = url
		}
	}
	return null
}

const SalesRoute = ({component: Component, ...rest}) => {
	const { authServices, data, location } = useContext(AppContext)
	const { isReady } = data
    return (
        <Route {...rest} render={props => (
            authServices.isSales() ? <Component {...props} />
            : ( isReady ? <Redirect to={authServices.isLoggedIn() ? '/account' : '/'} /> : null )
        )} />
    );
}

const GuestsRoute = ({component: Component, ...rest}) => {
	const { authServices, data } = useContext(AppContext)
	const { isReady } = data
	const isLoggedIn = authServices.isLoggedIn()
	if(!isReady) return null
    return <Route {...rest} render={props => ( !isLoggedIn ? <Component {...props} /> : <Redirect to={'/account'} /> )} />
}

const Routes = (props) => (
	<BrowserRouter>
		<Switch>
			<Route exact path='/' component={() => null} />
			<Route exact path='/promo/:key' component={PromoProcess} />

			<PrivateRoute exact path="/account" component={AccountHome} />
			<PrivateRoute exact path="/account/change-password" component={AccountChangePassword} />
			<PrivateRoute exact path="/account/settings" component={AccountSettings} />
			<PrivateRoute exact path="/account/business-profile" component={BusinessProfile} />
			<PrivateRoute exact path="/account/business-logo" component={BusinessLogo} />
			<PrivateRoute exact path="/account/posts" component={AccountPosts} />
			<PrivateRoute exact path="/account/affiliate" component={AccountAffiliate} />
			<PrivateRoute exact path="/account/saved-searches" component={SavedSearches} />
			<PrivateRoute exact path="/account/credits-and-points" component={CreditsAndPoints} />
			<PrivateRoute exact path="/account/add-funds" component={AddFunds} />
			<PrivateRoute exact path="/account/communicate" component={AccountCommunicate} />
			<PrivateRoute exact path="/account/messages" component={Threads} />
			<PrivateRoute exact path="/account/messages/:id" component={Thread} />

			<PrivateRoute exact path="/account/banner/list" component={BannerList} />
			<PrivateRoute exact path="/account/banner/create" component={BannerCreate} />
			<PrivateRoute exact path="/account/banner/edit/:id" component={BannerEdit} />
			<PrivateRoute exact path="/account/banner/pay/:id" component={BannerPay} />
			<PrivateRoute exact path="/account/banner/view/:id" component={BannerView} />

			<SalesRoute exact path="/account/leads" component={Leads} />
			<SalesRoute exact path="/account/leads/create" component={LeadCreate} />
			<SalesRoute exact path="/account/leads/view/:id" component={LeadView} />
			<SalesRoute exact path="/account/leads/edit/:id" component={LeadEdit} />

			<Route exact path='/page-not-found' component={NotFound} />
			<Route exact path='/unauthorized' component={Unauthorized} />
			<Route exact path='/server-error' component={ServerError} />
			<Route exact path="/banner/view/:id" component={BannerPreview} />

			<Redirect to="/page-not-found" />
		</Switch>
	</BrowserRouter>
)

export default Routes